import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { cancelVisit } from '../api';

// Owner Bookings & Cancellation v2 doc, Story 1 - a proper popup (reason + terms + explicit
// accept checkbox) replacing the bare window.prompt() this used to be. Visits carry no
// rentalAmount, so unlike the other 3 verticals' CancelBookingModal there's no refund breakdown
// to preview - the "terms" here are just that cancelling a visit is free, any time.
export default function VisitCancelModal({ visitId, show, onHide, onCancelled }) {
  const [reason, setReason] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setReason('');
    setTermsAccepted(false);
    setError('');
  }, [show, visitId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      setError('A cancellation reason is required.');
      return;
    }
    if (!termsAccepted) {
      setError('Please confirm you have read and accept the cancellation terms.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await cancelVisit(visitId, reason.trim());
      onCancelled();
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to cancel this visit request.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Cancel this visit request?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3 p-2 rounded bg-light small">
            <div className="fw-semibold mb-1">Cancellation terms</div>
            <div>Visit requests are free to schedule and free to cancel, any time before the visit starts.</div>
            <div>No payment or refund is involved - please let the owner know why you're cancelling so they can release the slot.</div>
          </div>
          {error && <Alert variant="danger" className="py-2">{error}</Alert>}
          <Form.Group className="mb-2" controlId="cancel-visit-reason">
            <Form.Label>Reason for cancelling</Form.Label>
            <Form.Control as="textarea" rows={2} value={reason} onChange={(e) => setReason(e.target.value)} required maxLength={500} />
          </Form.Group>
          <Form.Check
            type="checkbox"
            id="visit-cancel-terms-check"
            label="I have read and accept the cancellation terms above"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} disabled={submitting}>
            Keep visit
          </Button>
          <Button variant="danger" type="submit" disabled={submitting || !termsAccepted}>
            {submitting ? 'Cancelling…' : 'Confirm cancellation'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
